import { render } from "./ColorModal.vue?vue&type=template&id=4e5d20dc"
import script from "./ColorModal.vue?vue&type=script&lang=js"
export * from "./ColorModal.vue?vue&type=script&lang=js"

import "./ColorModal.vue?vue&type=style&index=0&id=4e5d20dc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__